import { useDispatch, useSelector } from "react-redux";
import "./ShareholderOpportunity.css";
import { useEffect } from "react";
import { AllShareholder } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const shareholderCards = [
  {
    id: 1,
    type: "static",
    title: "Static Shareholder",
    condition: "12 direct referrals within 12 months.",
    benefit:
      "5% of total company profit shared equally among all static shareholders",
  },
  {
    id: 2,
    type: "growth",
    title: "Growth Shareholder",
    condition:
      "12 direct referrals, each of them brings 4 customers within 12 months.",
    benefit:
      "10% of total company profit shared equally among growth shareholders",
  },
];

export default function ShareholderOpportunity() {
  const dispatch = useDispatch();

  const all_share_holder = useSelector(
    (state) => state?.common?.all_share_holder,
  );

  

  // useEffect(() => {
  //   dispatch(AllShareholder());
  // }, [dispatch]);

  return (
    <></>
    // <section className="shareholder-section">
    //   <div className="container">
    //     <h2 className="shareholder-heading">
    //       Share Holder Club. <span>Extra Income Opportunity</span>
    //     </h2>

    //     <p className="shareholder-desc">
    //       The Share Holder Club rewards members who actively grow the network.
    //       Complete 12 direct referrals within 12 months to become a Static
    //       Shareholder and enjoy an equal share of 5% of the company’s total
    //       profit. Take it further by building a strong team—12 direct referrals,
    //       each bringing 4 customers within 12 months and qualify as a Growth
    //       Shareholder, earning an equal share of 10% of the company’s total
    //       profit.
    //     </p>

    //     <div className="shareholder-cards">
    //       {all_share_holder?.map((item, index) => (
    //         <div className="shareholder-card" key={item.id}>
    //           <div className={`shareholder-image ${item.type}`}></div>
    //           <div className="shareholder-image-wrapper">
    //             <img
    //               src={`${IDS.IMG_URL}${item?.image}`}
    //               alt={item?.name || "Shareholder level"}
    //               className={`shareholder-image ${item?.type || ""}`}
    //               onError={(e) => {
    //                 e.target.src = "/images/placeholder-shareholder.jpg"; 
    //                 e.target.alt = "Image not available";
    //               }}
    //             />
    //           </div>

    //           <div className="shareholder-content">
    //             <h3>
    //               {index + 1}. {item?.name}
    //             </h3>

    //             <p className="label">Condition:</p>
    //             <p className="borderbottom">{item?.condition}</p>

    //             <p className="label">Benefit:</p>
    //             <p>{item?.benifit}</p>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // </section>
  );
}
